/** @typedef {import('@/types/api').MasterPackage} MasterPackage */

import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: MasterPackage[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchMasterPackagesPage(params = {}) {
  const { data } = await api.get('/masters/packages', { params })
  const parsed = parseMasterCatalogResponse(data, 'packages')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<MasterPackage[]>}
 */
export async function fetchMasterPackagesList(params = {}) {
  const { data } = await api.get('/masters/packages', { params })
  return data.data.packages
}

/**
 * @returns {Promise<MasterPackage[]>}
 */
export async function fetchMasterPackages() {
  return fetchMasterPackagesList()
}

/**
 * @param {number} packageId
 * @returns {Promise<MasterPackage>}
 */
export async function fetchMasterPackage(packageId) {
  const { data } = await api.get(`/masters/packages/${packageId}`)
  return data.data.package
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<MasterPackage>}
 */
export async function createMasterPackage(payload) {
  const { data } = await api.post('/masters/packages', payload)
  return data.data.package
}

/**
 * @param {number} packageId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<MasterPackage>}
 */
export async function updateMasterPackage(packageId, payload) {
  const { data } = await api.put(`/masters/packages/${packageId}`, payload)
  return data.data.package
}

export function formatPackageAmount(value) {
  const amount = Number(value)
  if (!Number.isFinite(amount)) return 'AED 0.00'
  return `AED ${amount.toFixed(2)}`
}
